"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContainerBase = exports.GridBase = void 0;
var _context = require("../../context");
var _constants = require("./constants");
const commonStyle = {
  flexBasis: 'auto',
  flexGrow: 0,
  display: 'flex',
  flexFlow: 'wrap',
  boxSizing: 'border-box'
};
const GridContainerBase = exports.GridContainerBase = (0, _context.styledWithTheme)('div')(_ref => {
  let {
    isNested
  } = _ref;
  return {
    ...commonStyle,
    width: "calc(100% + var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, "))"),
    marginLeft: "calc(var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ") * -1)"),
    marginTop: "calc(var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ") * -1)"),
    ...(isNested && {
      paddingLeft: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")"),
      paddingTop: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")")
    }),
    [".".concat(_constants.GRID_ITEM_CLASS_NAME)]: {
      paddingLeft: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")"),
      paddingTop: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")")
    }
  };
});
const GridBase = exports.GridBase = (0, _context.styledWithTheme)('div')(_ref2 => {
  let {
    theme: {
      mediaQueries
    },
    lg,
    md,
    sm
  } = _ref2;
  return {
    ...commonStyle,
    ...mediaQueries.xl({
      width: "calc(100% * ".concat(lg, " / ").concat(_constants.GRID_COLUMNS.lg, ")")
    }),
    ...mediaQueries.lg({
      width: "calc(100% * ".concat(lg, " / ").concat(_constants.GRID_COLUMNS.lg, ")")
    }),
    ...mediaQueries.md({
      width: "calc(100% * ".concat(md, " / ").concat(_constants.GRID_COLUMNS.md, ")")
    }),
    ...mediaQueries.sm({
      width: "calc(100% * ".concat(sm, " / ").concat(_constants.GRID_COLUMNS.sm, ")")
    })
  };
});